export const scriptLoaded = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.defer = true;
    script.addEventListener("load", () => resolve({ script, status: "ok" }));
    script.addEventListener("error", (error) => reject({ script, status: "error", error }));
    document.body.appendChild(script);
  });
};

export const imageLoaded = (path) => {
  return new Promise((resolve) => {
    //const img = new Image();
    const img = document.createElement("img");
    img.onload = () => resolve({ path, status: "ok" });
    img.onerror = (error) => resolve({ path, status: "error", error });

    img.src = path;
  });
};

export const scriptCleanup = (src) => {
  try {
    const scriptTag = document.querySelector(`script[src="${src}"]`);
    if (scriptTag) document.body.removeChild(scriptTag);
  } catch (error) {
    console.warn("Error during script cleanup");
  }
};

export const imagesLoaded = (paths) => {
  return Promise.all(paths.map(imageLoaded));
};

/**
 * Util function to return a promise which is resolved in provided milliseconds
 */
export const waitFor = (millSeconds) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, millSeconds);
  });
};

export const retryPromiseWithDelay = async (promise, nthTry, delayTime) => {
  try {
    const res = await promise;
    return res;
  } catch (e) {
    if (nthTry === 1) {
      return Promise.reject(e);
    }
    // wait for delayTime amount of time before calling this method again
    await waitFor(delayTime);
    return retryPromiseWithDelay(promise, nthTry - 1, delayTime);
  }
};
